import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  LISTA_NOTICIAS,
  CRIA_NOTICIA,
  EDITA_NOTICIA,
  DELETA_NOTICIA,
  TOGGLE_ATIVO_NOTICIA,
} from 'constants/ActionTypes';
import api from 'util/ApiComunicacao';
import {
  listaNoticiasSucesso,
  listaNoticiasErro,
  criaNoticiaSucesso,
  editaNoticiaSucesso,
  deletaNoticiaSucesso,
  toggleAtivoNoticiaSucesso,
  noticiasErro,
} from 'actions/Noticias';

/*#################################################################################################################*/
/* ------------------------------------------- Requests tipo GET --------------------------------------------------*/

const getNoticias = async (pagina, tamanhoPagina, busca) => {
  const params = new URLSearchParams({ pagina, tamanhoPagina });
  if (busca) params.append('busca', busca);
  return api.get(`/v1/noticias?${params}`).then(r => r).catch(e => e);
};

/*#################################################################################################################*/
/* ------------------------------------------ Requests tipo POST --------------------------------------------------*/

const postNoticia = async (formData) =>
  api.post('/v1/noticias', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r).catch(e => e);

/*#################################################################################################################*/
/* ------------------------------------------- Requests tipo PUT --------------------------------------------------*/

const putNoticia = async (id, formData) =>
  api.put(`/v1/noticias/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r).catch(e => e);

/*#################################################################################################################*/
/* ----------------------------------------- Requests tipo DELETE -------------------------------------------------*/

const deleteNoticia = async (id) =>
  api.delete(`/v1/noticias/${id}`).then(r => r).catch(e => e);

/*#################################################################################################################*/
/* ------------------------------------------ Requests tipo PATCH -------------------------------------------------*/

const patchToggleAtivo = async (id) =>
  api.patch(`/v1/noticias/${id}/ativo`).then(r => r).catch(e => e);

/*#################################################################################################################*/
/* ----------------------------------------------- Sagas ----------------------------------------------------------*/

function* listarSaga({ payload }) {
  try {
    const { pagina, tamanhoPagina, busca } = payload;
    const result = yield call(getNoticias, pagina, tamanhoPagina, busca);
    if (result.response && result.response.status >= 400) {
      yield put(listaNoticiasErro('Erro ao carregar notícias.'));
    } else {
      yield put(listaNoticiasSucesso(result.data));
    }
  } catch (error) {
    yield put(listaNoticiasErro('Erro ao carregar notícias.'));
  }
}

function* criarSaga({ payload }) {
  try {
    const result = yield call(postNoticia, payload);
    if (result.response && result.response.status >= 400) {
      const msg = result.response.data?.notifications?.[0]?.message || 'Erro ao criar notícia.';
      yield put(noticiasErro(msg));
    } else {
      yield put(criaNoticiaSucesso());
    }
  } catch (error) {
    yield put(noticiasErro('Erro ao criar notícia.'));
  }
}

function* editarSaga({ payload }) {
  try {
    const result = yield call(putNoticia, payload.id, payload.formData);
    if (result.response && result.response.status >= 400) {
      const msg = result.response.data?.notifications?.[0]?.message || 'Erro ao editar notícia.';
      yield put(noticiasErro(msg));
    } else {
      yield put(editaNoticiaSucesso());
    }
  } catch (error) {
    yield put(noticiasErro('Erro ao editar notícia.'));
  }
}

function* deletarSaga({ payload }) {
  try {
    const result = yield call(deleteNoticia, payload.id);
    if (result.response && result.response.status >= 400) {
      yield put(noticiasErro('Erro ao excluir notícia.'));
    } else {
      yield put(deletaNoticiaSucesso());
    }
  } catch (error) {
    yield put(noticiasErro('Erro ao excluir notícia.'));
  }
}

function* toggleAtivoSaga({ payload }) {
  try {
    const result = yield call(patchToggleAtivo, payload.id);
    if (result.response && result.response.status >= 400) {
      yield put(noticiasErro('Erro ao alterar status da notícia.'));
    } else {
      yield put(toggleAtivoNoticiaSucesso());
    }
  } catch (error) {
    yield put(noticiasErro('Erro ao alterar status da notícia.'));
  }
}

export function* watchListar() { yield takeEvery(LISTA_NOTICIAS, listarSaga); }
export function* watchCriar() { yield takeEvery(CRIA_NOTICIA, criarSaga); }
export function* watchEditar() { yield takeEvery(EDITA_NOTICIA, editarSaga); }
export function* watchDeletar() { yield takeEvery(DELETA_NOTICIA, deletarSaga); }
export function* watchToggleAtivo() { yield takeEvery(TOGGLE_ATIVO_NOTICIA, toggleAtivoSaga); }

export default function* rootSaga() {
  yield all([
    fork(watchListar),
    fork(watchCriar),
    fork(watchEditar),
    fork(watchDeletar),
    fork(watchToggleAtivo),
  ]);
}
